import axios from 'axios';

export const getChoices = async (reportType, choiceType, params = {}) => {
  let url = `/reports/${reportType}/choices/${choiceType}/`;

  if (params instanceof URLSearchParams) {
    url += `?${params.toString()}`;
    const response = await axios.get(url);
    return response;
  } else if (Object.keys(params).length > 0) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => searchParams.append(key, v));
      } else {
        searchParams.append(key, value);
      }
    });
    url += `?${searchParams.toString()}`;
    const response = await axios.get(url);
    return response;
  }

  const response = await axios.get(url);
  return response;
};

export const getEoreDonorChoices = (params = {}) => getChoices('eore', 'donor', params);
export const getEoreCustomerChoices = (params = {}) => getChoices('eore', 'task-customer', params);
export const getEoreTeamChoices = (params = {}) => getChoices('eore', 'team-id', params);
export const getEoreLocalCommunityChoices = (params = {}) => getChoices('eore', 'local-community', params);
export const getEoreSettlementChoices = (params = {}) => getChoices('eore', 'settlement-name', params);
export const getEorePlaceTypeChoices = (params = {}) => getChoices('eore', 'place-type-imsma', params);
export const getEoreTypeChoices = (params = {}) => getChoices('eore', 'eore-type-imsma', params);
export const getEoreTypeOfSessionChoices = (params = {}) => getChoices('eore', 'eore-type-imsma', params);

export const getNtsDonorChoices = (params = {}) => getChoices('nts', 'donor', params);
export const getNtsCustomerChoices = (params = {}) => getChoices('nts', 'task-customer', params);
export const getNtsTypeChoices = (params = {}) => getChoices('nts', 'type', params);
export const getNtsTeamChoices = () => getChoices('nts', 'team-id');
export const getNtsLocalCommunityChoices = () => getChoices('nts', 'local-community');
export const getNtsHazardNameChoices = () => getChoices('nts', 'hazard-name');

export const getHaDonorChoices = (params = {}) => getChoices('ha', 'donor', params);
export const getHaCustomerChoices = (params = {}) => getChoices('ha', 'task-customer', params);
export const getHaTeamChoices = () => getChoices('ha', 'team-id');
export const getHaLocalCommunityChoices = () => getChoices('ha', 'local-community');
export const getHaHazardNameChoices = () => getChoices('ha', 'hazard-name');
export const getHaHazardAreaTypeChoices = () => getChoices('ha', 'hazard-area-type');
export const getHaHazardTypeChoices = () => getChoices('ha', 'hazard-type');

export const getClearanceDonorChoices = () => getChoices('clearance', 'donor');
export const getClearanceTeamChoices = () => getChoices('clearance', 'team-id');
export const getClearanceValidationStatusChoices = () => getChoices('clearance', 'validation-status');
export const getClearanceMethodChoices = () => getChoices('clearance', 'method');
export const getClearanceTaskChoices = (params = {}) => {
  const url = '/reports/clearance/daily/filters/choices/';
  return axios.get(url, { params: { choice_name: 'clearance_task', ...params } });
};

export const getClearanceTaskChoicesForWeekly = (params = {}) => {
  const url = '/reports/clearance/weekly/filters/choices/';
  return axios.get(url, { params: { choice_name: 'clearance_task', ...params } });
};

export const getHaReportChoices = (params = {}) => {
  const url = '/reports/clearance/daily/filters/choices/';
  return axios.get(url, { params: { choice_name: 'ha_report', ...params } });
};

export const getGlobalMapTeamChoices = () => getChoices('global-map', 'team-id');
export const getGlobalMapInternalIdChoices = () => getChoices('global-map', 'internal-id');
export const getGlobalMapImsmaIdChoices = () => getChoices('global-map', 'imsma-id');
export const getGlobalMapRegionChoices = () => getChoices('global-map', 'region');
export const getGlobalMapDistrictChoices = () => getChoices('global-map', 'district');
export const getGlobalMapLocalCommunityChoices = () => getChoices('global-map', 'local-community');
export const getGlobalMapSettlementChoices = () => getChoices('global-map', 'settlement-name');

export const getFilterChoices = getChoices;

export const CHOICE_TYPES = {
  DONOR: 'donor',
  TEAM_ID: 'team-id',
  LOCAL_COMMUNITY: 'local-community',
  SETTLEMENT_NAME: 'settlement-name',
  PLACE_TYPE_IMSMA: 'place-type-imsma',
  EORE_TYPE_IMSMA: 'eore-type-imsma',
  TYPE_OF_SESSION: 'eore-type-imsma',
  HAZARD_NAME: 'hazard-name',
  NTS_TYPE: 'nts-type',
  HAZARD_AREA_TYPE: 'hazard-area-type',
  HAZARD_TYPE: 'hazard-type',
  VALIDATION_STATUS: 'validation-status',
  METHOD: 'method',
  INTERNAL_ID: 'internal-id',
  IMSMA_ID: 'imsma-id',
  REGION: 'region',
  DISTRICT: 'district'
};

export const REPORT_TYPES = {
  EORE: 'eore',
  NTS: 'nts',
  HA: 'ha',
  CLEARANCE: 'clearance',
  GLOBAL_MAP: 'global-map'
};